export interface sessionData{
    status:boolean,
    userData:{
        userid:string,
        username:string,
        administrator:boolean,
        otpCode:boolean,
        empCode:string,
        alias:string|null,
        tpdata?:db_timepro_person,
        flags:{
            salaryResign:boolean,
        }
    }
}
export interface API_auth_req{
    userid:string|null,
    password:string|null,
    otpToken:string|null,
}
export interface apiResponseData_auth{
    status:boolean,//認証結果
    lock?:boolean,
    //以下認証結果=faleは入らない
    userid?:string,
    username?:string,
    administrator?:boolean,
    totp?:boolean,
    lastLogin?:string,
    tpdata?:db_timepro_person,
    flags?:{
        salaryResign:boolean,
    }
}
export interface API_passwordChange_Req{
    current:string|null,
    password:string|null,
    otpToken?:string|null,
}
export const ePasswordChangeStatus = {
    sccess:1,
    currentAuthFaild:-1,
}
export interface API_passwordChange_Res{
    status:number
}
export interface SalaAPI_TOTP_NewSecret_res{
    key:string
    url:string,
    qrcodeDataUrl:string,
}
interface db_timepro_person{
    EmpCode:string,
    WordName:string,
    DepCodeAll:string,
    RetireFlag:number,
    RetireYMD:number,
    DepName:string,
    DepNameAll:string,
    BounusCount:number,
}
export interface SalaAPI_user_res{
    userid:string,
    username:string,
    empcode:string,
    useOtp:boolean,
    lastLogin:string|null,
    alias:string|null,
    retire:string|null
    depname:string|null,
}
export interface SalaAPI_AddUser_res{
    userid:string|null,
    password?:string
}
export interface SalaAPI_ModUser_req{
    userId?:string,
    userName?:string,
    empCode?:string,
    passwordRaw?:string,
    alias?:string,
    otpCode?:string|null,
    retire?:Date|null,
    depnameShrt?:string|null,
    depname?:string|null,
    depcode?:string|null,
    ecAdmin?:boolean|null,
    ecAdress1?:string|null,
    ecAdress2?:string|null,
    ecAdress3?:string|null,
    ecAdress4?:string|null,
    lastLogin?:Date,
}
export interface SalaAPI_GetSalary_Res{
    period:{start:string,end:string},
    list:{[ym:string]:PayInfo},
    viewData:Array<ViewDeginDetail>,
    personInfo?:personInfo,
}
export interface SalaAPI_GetSalaryTax_Res extends SalaAPI_GetSalary_Res{
    viewDataTax?:Array<ViewDeginDetail>,
}
type DefItemName = {itemCode:number,valueType:string,itenName:string};
export type Defitems = Array<DefItemName & {value:number|string|null}>;
export interface PayInfo{
    empCode:string,
    atDate:string,
    payDate:string,
    period?:{
        start:string,
        end:string,
    }
    defItems:Defitems,
}
interface personInfo{
    TaxFlagWife0:number,
    TaxFlagWife1:number,
    TaxFlagWife2:number,
    TaxFlagWife3:number,
    TaxFlagWife4:number,
    TaxFlagWife5:number,
    TaxFlagOther0:number,
    TaxFlagOther1:number,
    TaxFlagOther2:number,
    TaxFlagOther3:number,
    TaxFlagOther4:number,
    Support0:number,
    Support1:number,
    Support2:number,
    Support3:number,
    Support4:number,
    Support5:number,
    Support6:number,
    Support7:number,
    WordName:string,
    ByteName:string,
    ZIPCode1:string,
    ZIPCode2:string,
    Address1:string,
    Address2:string,
}


export type RefreshType = "MatchTimePro";
export interface SalaAPI_Refresh_Req{
    refreshType:RefreshType
}
export type DefnameTable = "Pay"|"Bounus"|"YEndCab"|"YEndTax";
export type DefItemNameList = Array<DefItemName>;
interface viewDeginDetail {
    title:string,
    order:number|null,
    cards:Array<{
        title:string,
        order:number|null,
        //defname?:string,
        itemCode?:number,
        value?:number|null,
        calc?:viewDeginCalc,
        children?:Array<{
            title:string,
            order:number|null,
            //defname:string,
            itemCode?:number,
            value?:number|null,
            calc?:viewDeginCalc,
        }>
    }>
}

export interface API_ViewColumn_Respons{
    tableItmes:DefItemNameList,
    curCfg:Array<viewDeginDetail>|null,
}
export type viewDegin = Array<ViewDeginDetail>;
export interface ViewDeginDetail {
    title:string,
    order:number,
    cards:Array<viewDeginCard>,
    _key?:number,
}
interface viewDeginCalc{
    type:"+"|"-"|"*"|"/"|"?"|"="|"."|null,
    num?:number,
    _def?:boolean,
    itemCode?:number,
    calc?:viewDeginCalc,
    value?:{
        t:string|number,
        f:string|number,
    }
    _calc?:boolean,
}
export interface viewDeginCard{
    title:string,
    itemCode?:number,
    value?:number|null|string,
    _child?:boolean,
    children?:Array<viewDeginCardChild>,
    order?:number,
    _key?:number,
    _childrenCols?:number,
    _class?:Array<string>,
    _calc?:boolean,
    calc?:viewDeginCalc,
}
interface viewDeginCardChild{
    _key?:number,
    title:string,
    _def?:boolean,
    itemCode?:number,
    value?:number|null|string,
    _calc?:boolean,
    calc?:viewDeginCalc,
    order?:number,
}
export const PDFFormType = {
    "password":1,
    "salary":2,
    "bonus":3,
    "yend":4,
    "tax":5,
    "r_sal1":11,
    "r_sal2":12,
    "r_sal3":13,
    "r_sal4":14,
    "r_sal5":15,
    "r_sal6":16,
}
export interface PdfResponse{
    status:boolean,
    code:number,
    pdfdata?:{
        filename:string,
        data:string,
    }
}
export type apiResponseData_timeProUsers = Array<apiResponseData_timeProUser>;
interface apiResponseData_timeProUser{
    empcode:string,
    name:string,
    depCode:string,
    isRetire:boolean,
    retireDate?:string|null,
    depnameShrt:string|null,
    depname:string|null,
    depcode:string|null,
}
export interface SalaAPI_column_Res{
    FORM_ID:number,
    POS_X:number,
    POS_Y:number,
    FONT_SIZE:number,
    TABLE_ITEM_NO:number|null,
    WIDTH:number,
    HEIGHT:number,
    ALIGN:string|null,
    OPTIONS:Array<viewDeginCalc>|null,
}
export interface SalaAPI_FromColumn_Respons{
    tableItmes:DefItemNameList,
    form:db_TB_FORM|null,
    colomun:Array<db_TB_FORM_COLUMN>|null
}
export interface API_FromColumn_Request{
    colomun:Array<db_TB_FORM_COLUMN>|null,
    tempPdf?:string,
}
export interface SalaAPI_MyResignSalary_Res{
        formCode: number;
        format: number;
        defItem: MyResignSalaryItem,
}
export interface MyResignSalaryItem {
    rdateRaw:Date,
    adateRaw:Date,
    userid: string;
    username: string;
    aYear: string;
    aMonth: string;
    baseSal: string;
    jobLevel: string;
    gobo: string;
    baseReword: string;
    contiReword: string;
    rDate:string,
    cutRate?: undefined;
    redece?:string,
    reBaseSal?:string,
    fstAdjDefUpGob?:string,
    fstAdjDefUpNum?:string,
    fstAdjBaseUpGob?:string,
    fstAdjBaseUpNum?:string,
    fstAdjTotalGob?:string,
    fstAdjTotalNum?:string,
    mTblClmBase?:string,
    mTblClmMng?:string,
    mTblClmWrk?:string,
    mTblClmCls?:string,
    mTblClmAll?:string,
    cTblClmBase?:string,
    cTblClmMng?:string,
    cTblClmWrk?:string,
    cTblClmCls?:string,
    cTblClmAll?:string,
    untripBase?:string,
    untripNum?:string,
    untripDecereBase?:string,
}
interface db_TB_FORM{
    ID:number,
    FNAME:string,
    FFILE:string,
}

interface db_TB_FORM_COLUMN{
    FORM_ID:number,
    POS_X:number,
    POS_Y:number,
    WIDTH:number,
    HEIGHT:number,
    FONT_SIZE:number,
    TABLE_ITEM_NO:number|null,
    ALIGN:string|null,
    OPTIONS:Array<viewDeginCalc>|null,
}
export interface SslaAPI_SystemConfig{
    period:PeriodConfig
}
interface PeriodConfig{
    saraly:number,
    retire:number,
    yend:number,
    saralyPay:string,
    bounusPay:string,
    yendPay:string,

}
export interface PeriodConfigSet{
    saraly?:number,
    retire?:number,
    yend?:number,
    saralyPay?:string,
    bounusPay?:string,
    yendPay?:string,

}
export type SalaAPI_ResignSalary_Res = Array<DB_TB_SALA_RESIGN>;
export type SalaAPI_ResignSalary_Req = Array<DB_TB_SALA_RESIGN>;
export interface DB_TB_SALA_RESIGN{
    USERID:string,
    ADATE:string
    RDATE:string,
    FROMAT:number,
    JOB_LEVEL:string,
    BF_JOB_CLASS:number,
    JOB_CLASS:number,
    BF_BASE_SALARY:number,
    CUT_RATE:number,
    BASE_SALARY:number,
    CONTIN_REWARD:number,
    MANAGE_REWARD:number,
    WORK_REWARD:number,
    CLASS_REWARD:number,
    UNTRIP_DECREASE:number,
    ADJ_PIT:number,
    ADJ_NUM:number,
    U_GOBO:number,
}